import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../components/aboutComponent.vue'),
  },
  {
    path: '/login',
    name: 'RegisterForm',
    component: () => import('../components/common/RegisterForm.vue'),
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('../components/common/ResetPasswordForm.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../components/aboutComponent.vue'),
  },
  {
    path: '/feed',
    name: 'feed',
    component: HomeView,
  },
  {
    path: '/today',
    name: 'today',
    component: HomeView,
  },
  {
    path: '/measurements',
    name: 'measurements',
    component: () => import('../components/measurementsComponent.vue'),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfilePage.vue'),
  },
  {
    path: '/trends',
    name: 'trends',
    component: () => import('../components/analytics/trendsPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('../components/notFound.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
